"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermissionName = void 0;

var getPermissionName = function getPermissionName(state, ownProps) {
  return ownProps.name;
};

exports.getPermissionName = getPermissionName;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/selectors/propSelectors.js
// module id = 665
// module chunks = 209 210 211 212